//USER
export const LOG_IN="LOG_IN"
export const LOG_OUT="LOG_OUT"
export const GET_USERS="GET_USERS"
export const ADD_USER="ADD_USER"
export const EDIT_USER="EDIT_USER"
export const DELETE_USER="DELETE_USER"
export const SIGN_IN="SIGN_IN"

//BUSINESS
export const GET_BUSINESSES="GET_BUSINESSES"
export const ADD_BUSINESS="ADD_BUSINESS"
export const EDIT_BUSINESS="EDIT_BUSINESS"
export const DELETE_BUSINESS = "DELETE_BUSINESS";
export const TOGGLE_IS_SHOW="TOGGLE_IS_SHOW"

//JOB
export const GET_JOBS="GET_JOBS"
export const ADD_JOB="ADD_JOB"
export const EDIT_JOB="EDIT_JOB"
export const DELETE_JOB="DELETE_JOB"

//REPORT
export const GET_REPORTS="GET_REPORTS"
export const ADD_REPORT="ADD_REPORT"
